export const GTM_CONTAINER_ID_PLACEHOLDER = '__GTM_CONTAINER_ID__';
export const HOSTNAME_PLACEHOLDER = '__HOSTNAME__';
export const ENVIRONMENT_PLACEHOLDER = '__ENVIRONMENT__';
export const INSTANCE_NAME_PLACEHOLDER = '__INSTANCE_NAME__';
export const SEO_BOTS_META_PLACEHOLDER = '__SEO_BOTS_META__';

export const MOBILE_NAV_BREAKPOINT = 1200;

// Grouped version of @app/shared/labels/allowed-mimetypes.ts
export const AllowedMimeTypes: Readonly<Record<string, readonly string[]>> = {
  CSV: ['text/plain', 'text/csv', 'application/csv'],
  JSON: ['application/json'],
  PDF: ['application/pdf'],
  IMAGE: ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'image/svg+xml', 'image/tiff', 'image/webp'],
  MS_WORD: [
    'application/msword',
    'application/CDFV2',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  MS_EXCEL: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
  MS_PPT: [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/x-ole-storage',
  ],
  DICOM: ['application/dicom'],
  ZIP: ['application/zip'],
  FCS: ['application/vnd.isac.fcs'],
} as const;

export const ALLOWED_MIME_TYPES: string[] = Object.values(AllowedMimeTypes).flat();

export type PossibleHIPAAWarning =
  | 'PossibleDateData'
  | 'PossiblePhoneData'
  | 'PossibleMRNData'
  | 'PossibleSSNData'
  | 'PossibleZIPData'
  | 'PossibleEmailData';

export enum SafeType {
  HTML = 'html',
  STYLE = 'style',
  SCRIPT = 'script',
  URL = 'url',
  RESOURCEURL = 'resourceUrl',
  DEFAULT = 'default',
}

export const ProjectFlags = {
  CAN_VIEW_META: '_can_view_meta',
  CAN_MANAGE_PERMISSION: '_can_manage_permission',
  CAN_UPDATE_META: '_can_update_meta',
  CAN_DELETE_META: '_can_delete_meta',
  CAN_UPLOAD_DATA: '_can_upload_data',
  CAN_DELETE_DATA: '_can_delete_data',
  CAN_DOWNLOAD_DATA: '_can_download_data',
} as const;

export type ProjectFlagKey = keyof typeof ProjectFlags;
export type ProjectFlagValue = (typeof ProjectFlags)[ProjectFlagKey];

export const DatasetFlags = {
  CAN_VIEW_META: '_can_view_meta',
  CAN_MANAGE_PERMISSION: '_can_manage_permission',
  CAN_VIEW_PERMISSION: '_can_view_permission',
  CAN_UPDATE_META: '_can_update_meta',
  CAN_DELETE_META: '_can_delete_meta',
  CAN_DELETE_DATA: '_can_delete_data',
  CAN_UPLOAD_DATA: '_can_upload_data',
  CAN_DOWNLOAD_ALL_DATA: '_can_download_all_data',
  CAN_DOWNLOAD_LATEST_DATA: '_can_download_latest_data',
} as const;

export type DatasetFlagKey = keyof typeof DatasetFlags;
export type DatasetFlagValue = (typeof DatasetFlags)[DatasetFlagKey];

export const REDCAP_TOKEN_PLACEHOLDER = '#'.repeat(32);
